import type { FC } from 'react'

import { Tooltip } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import ContentSaveOutlineIcon from 'mdi-react/ContentSaveOutlineIcon'
import { twJoin } from 'tailwind-merge'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'

export const UnsavedChangesButton: FC<{
  isLoading: boolean
  hasUnsavedChanges: boolean
  error?: boolean
  disabled?: boolean
  onClick?: () => void
}> = ({ error, hasUnsavedChanges, isLoading, disabled, onClick }) => {
  const translate = useTranslation()
  const content = error
    ? translate('Oops! Resolve form errors first.')
    : hasUnsavedChanges
      ? translate("NB! You've got unsaved changes.")
      : ''

  return (
    <span id="unsaved-changes">
      <Button
        className={twJoin(
          hasUnsavedChanges &&
            !isLoading &&
            'selected:bg-yellow-400 bg-amber-200 transition duration-500 ease-in-out hover:bg-yellow-400 focus:bg-yellow-400 active:bg-yellow-400'
        )}
        disabled={disabled || error}
        type="submit"
        Icon={<ContentSaveOutlineIcon />}
        isLoading={isLoading}
        onClick={onClick}
      >
        <Translation id="Save changes" />
        <Tooltip anchorId="unsaved-changes" size="large" content={content} />
      </Button>
    </span>
  )
}
